module.exports = "<div mat-dialog-content style=\"text-align: center\">\r\n        <p>You have insufficient balance</p>\r\n</div>"